import { ListPartnersQuery_partnership_listPartners_partners } from 'src/api/queries/__generated__/ListPartnersQuery';
import { ComboInputQuestion } from 'src/lib/flow/FlowQuestion';
import { useGetBuilderPartnersQuery } from 'src/store/api';

import SelectInput from './SelectInput';

type BuilderPartnersSelectInputProps = {
  question: ComboInputQuestion;
  value?: string;
};

const builderToOption = (partner: ListPartnersQuery_partnership_listPartners_partners) => ({
  label: partner.displayName,
  value: partner.identifier,
});

const BuilderPartnersSelectInput: React.FC<BuilderPartnersSelectInputProps> = ({
  question,
  value,
}) => {
  const { data, isLoading } = useGetBuilderPartnersQuery();

  return (
    <SelectInput
      question={{ ...question, options: data ? data.map(builderToOption) : [] }}
      isLoading={isLoading}
      value={value}
    />
  );
};

export default BuilderPartnersSelectInput;
